export default () => ({
  id: null,
  name: null,
  color: null,
});
